import {Mapper} from '@s-ui/domain'

const ORDER = {DESC: 'desc', ASC: 'asc'}

/**
 * You can see BE contract on:
 * Search: https://confluence.mpi-internal.com/pages/viewpage.action?pageId=139184151
 * Alerts: https://ms-mt--api-web.global-pre.spain.schibsted.io/swagger-ui.html
 */
export default class SearchRequestJSONToSearchParamsRequestJSONMapper extends Mapper {
  constructor({config}) {
    super({config})
    this._config = config
    this._SORT_FIELDS = this._config.get('SORT_FIELDS')
    this._defaultSortBy = this._config.get('SORT_FIELDS').RELEVANCE
    this._defaultSortOrder = this._config.get('ORDER').DESC
    this._adsListSize = this._config.get('search').ADS_LIST_SIZE
    this._listingSectionIds = this._config.get('COMMON').LISTING_SECTION_IDS

    this._unselectedOfferType = this._config.get('search').UNSELECTED_OFFER_TYPE

    const {
      ALL_OFFER_TYPES,
      OFFER_TYPE_DEMONSTRATION,
      OFFER_TYPE_KM0,
      OFFER_TYPE_MANAGEMENT,
      OFFER_TYPE_NEW,
      OFFER_TYPE_SECOND_HAND,
      OFFER_TYPE_SUBSTITUTION,
      SEGUNDA_MANO_CATEGORY1_ID
    } = this._config.get('search')

    this._allOfferTypes = ALL_OFFER_TYPES
    this._secondHandCategory1Id = SEGUNDA_MANO_CATEGORY1_ID
    this._offerTypes = {
      DEMONSTRATION: OFFER_TYPE_DEMONSTRATION,
      KM0: OFFER_TYPE_KM0,
      MANAGEMENT: OFFER_TYPE_MANAGEMENT,
      NEW: OFFER_TYPE_NEW,
      SECOND_HAND: OFFER_TYPE_SECOND_HAND,
      SUBSTITUTION: OFFER_TYPE_SUBSTITUTION
    }

    // Only enabled in coches
    this._hasKm0OfferTypeEnabled = Boolean(this._offerTypes.KM0)
  }

  setParams = ({
    batteryCapacity,
    bodyTypeIds,
    category1Id,
    category2Id,
    categoryId,
    chargingTimeFastMode,
    chargingTimeStandardMode,
    colorIds,
    commitmentMonths,
    contractId,
    doors,
    drivenWheelsIds,
    electricAutonomy,
    entry,
    environmentalLabels,
    equipments,
    excludedAdIds,
    excludedVehicles,
    fee,
    filteredOfferTypeId,
    financedPrice,
    fuelTypeIds,
    hasInstalment,
    hasOnlineFinancing,
    hasPhoto,
    hasPriceDrop,
    hasReservation,
    hasStock,
    hasWarranty,
    hp,
    instalment,
    isCertified,
    isFinanced,
    kms,
    listingSectionId,
    litres,
    location,
    luggageCapacity,
    makeId,
    maxTerms,
    model,
    monthlySubscriptionFee,
    offerTypeId,
    onlyPeninsula,
    page = 1,
    price,
    priceDrop,
    priceRank,
    provinceIds,
    rating,
    searchText,
    seats,
    sellerTypeId,
    size,
    sortBy = this._defaultSortBy,
    sortOrder = this._defaultSortOrder,
    subscriptionVehicleState,
    targetBuyer,
    transmissionTypeId,
    vehicleLength,
    vehicles,
    version,
    year
  }) => {
    this._batteryCapacity = batteryCapacity
    this._bodyTypeIds = bodyTypeIds
    this._category1Id = category1Id
    this._category2Id = category2Id
    this._categoryId = categoryId
    this._chargingTimeFastMode = chargingTimeFastMode
    this._chargingTimeStandardMode = chargingTimeStandardMode
    this._colorIds = colorIds
    this._commitmentMonths = commitmentMonths
    this._contractId = contractId
    this._doors = doors
    this._drivenWheelsIds = drivenWheelsIds
    this._electricAutonomy = electricAutonomy
    this._entry = entry
    this._environmentalLabels = environmentalLabels
    this._equipments = equipments
    this._excludedAdIds = excludedAdIds
    this._excludedVehicles = excludedVehicles
    this._fee = fee
    this._filteredOfferTypeId = filteredOfferTypeId
    this._fuelTypeIds = fuelTypeIds
    this._hasInstalment = hasInstalment
    this._hasOnlineFinancing = hasOnlineFinancing
    this._hasPhoto = hasPhoto
    this._hasPriceDrop = hasPriceDrop
    this._hasReservation = hasReservation
    this._hasStock = hasStock
    this._hasWarranty = hasWarranty
    this._hp = hp
    this._instalment = instalment
    this._isCertified = isCertified
    this._isFinanced = typeof financedPrice === 'boolean' ? financedPrice : isFinanced
    this._kms = kms
    this._listingSectionId = listingSectionId
    this._litres = litres
    this._location = location
    this._luggageCapacity = luggageCapacity
    this._makeId = makeId
    this._maxTerms = maxTerms
    this._model = model
    this._monthlySubscriptionFee = monthlySubscriptionFee
    this._offerTypeId = offerTypeId
    this._onlyPeninsula = onlyPeninsula
    this._page = page
    this._price = price
    this._priceDrop = priceDrop
    this._priceRank = priceRank
    this._provinceIds = provinceIds
    this._rating = rating
    this._searchText = searchText
    this._seats = seats
    this._sellerTypeId = sellerTypeId
    this._size = size
    this._sortBy = sortBy
    this._sortOrder = sortOrder
    this._subscriptionVehicleState = subscriptionVehicleState
    this._targetBuyer = targetBuyer
    this._transmissionTypeId = transmissionTypeId
    this._vehicles = vehicles
    this._vehicleLength = vehicleLength
    this._version = version
    this._year = year

    return this
  }

  cleanUndefinedProperties(object) {
    return JSON.parse(JSON.stringify(object))
  }

  getCategories = () => {
    const category1Ids =
      this._categoryId || this._category1Id ? this.toArray(this._categoryId || this._category1Id) : undefined

    const category2Ids = this._category2Id ? this.toArray(this._category2Id) : undefined

    const hasCategories = Boolean(category1Ids) || Boolean(category2Ids)

    if (!hasCategories) return

    return this.cleanUndefinedProperties({
      category1Ids,
      category2Ids
    })
  }

  getCommitmentMonths = () => {
    return {commitmentMonths: this._commitmentMonths}
  }

  getOfferTypeIds = () => {
    const {_offerTypeId, _filteredOfferTypeId, _offerTypes, _unselectedOfferType, _allOfferTypes} = this

    const isUnselected = id => id === _unselectedOfferType

    const groupKm0 = [_offerTypes.KM0, _offerTypes.SUBSTITUTION, _offerTypes.MANAGEMENT, _offerTypes.DEMONSTRATION]

    const groupSecondHand = [_offerTypes.SECOND_HAND, ...groupKm0]

    if (isUnselected(_offerTypeId)) {
      if (isUnselected(_filteredOfferTypeId)) return _allOfferTypes
      if (_filteredOfferTypeId === _offerTypes.KM0) return groupKm0
      if (_filteredOfferTypeId === _offerTypes.NEW) return [_offerTypes.NEW]
      return [_filteredOfferTypeId]
    }

    if (_offerTypeId === _offerTypes.KM0) {
      return _filteredOfferTypeId === _offerTypes.NEW ? [_offerTypes.NEW] : groupKm0
    }

    if (_offerTypeId === _offerTypes.SECOND_HAND) {
      return groupSecondHand
    }

    return _offerTypeId !== undefined ? [_offerTypeId] : null
  }

  getVehicles = () => {
    if (this._vehicles?.length) {
      const vehicles = this._vehicles.map(({make, makeId, model = {}, version}) => ({
        make: make || undefined,
        makeId: makeId || 0,
        model: model ? model.name : '',
        modelId: model ? model.id : 0,
        version: version || undefined
      }))

      return vehicles.map(this.cleanUndefinedProperties).filter(vehicle => Object.keys(vehicle).length)
    }

    const vehicle = [
      {
        make: this._make,
        makeId: this._makeId,
        modelId: this._model?.id,
        model: this._model?.name,
        version: this._version
      }
    ]

    const vehicles = vehicle.map(this.cleanUndefinedProperties).filter(vehicle => Object.keys(vehicle).length > 0)

    return vehicles.length ? vehicles : undefined
  }

  toArray = value => (value ? [value] : [])

  getFee = () => {
    return this._fee && {fee: this._fee}
  }

  getPriceRange = ({isFinanced, hasInstalment}) => {
    if (isFinanced) return {isFinanced: true, financedPrice: this._price}
    else if (hasInstalment)
      return this._instalment?.from === null && this._instalment?.to === null
        ? {hasInstalment: true, instalment: {...this._instalment, from: 1}}
        : {hasInstalment: true, instalment: this._instalment}
    else return {isFinanced: false, price: this._price}
  }

  getPrices = hasInstalment => {
    const priceObject = {price: this._price}

    if (typeof this._isFinanced !== 'boolean' && !hasInstalment) return priceObject

    return this.getPriceRange({
      isFinanced: this._isFinanced,
      hasInstalment
    })
  }

  getPriceRank = () => {
    return this._priceRank ? {priceRank: this._priceRank} : undefined
  }

  getCubicCapacity = () => {
    const {from, to} = this._litres || {}

    // We check this because litres has always the shape: litres= {from: null, to: null}
    // so in order to do not return it, we check for the inner values
    if (from || to) {
      return {cubicCapacity: this._litres}
    }
  }

  getColorIds = () => {
    if (this._colorIds && this._colorIds.length > 0) {
      return {colorIds: this._colorIds}
    }
  }

  _getDoors = () => {
    const {from, to} = this._doors || {}
    // We check this because doors has always the shape: doors= {from: null, to: null}
    // so in order to do not return it, we check for the inner values
    if (from || to) {
      return this._doors
    }
  }

  _getSeats = () => {
    const {from, to} = this._seats || {}
    // We check this because seats has always the shape: seats= {from: null, to: null}
    // so in order to do not return it, we check for the inner values
    if (from || to) {
      return this._seats
    }
  }

  _getSortBy = ({sortBy}) => {
    if (sortBy === this._SORT_FIELDS.MONTHLY_SUBSCRIPTION_FEE) return this._SORT_FIELDS.FEE
    return sortBy
  }

  _getLocation = () => {
    const {radio: distance, lat: latitude, long: longitude, text, provinceId} = this._location || {}

    // We check this because location has always the shape: location= {radio: null, lat: null, long: null, text: null}
    if (!latitude || !longitude) return

    return {
      distance,
      latitude,
      longitude,
      text,
      provinceId
    }
  }

  _getExcludedVehicles = () => {
    if (!this._excludedVehicles?.length) return undefined

    // A model id of 0 means the whole make is excluded, so only makeId is sent
    const excludedVehicles = this._excludedVehicles
      .filter(({makeId}) => Boolean(makeId))
      .map(({makeId, model}) => ({makeId: Number(makeId), ...(model?.id && {modelId: Number(model.id)})}))

    return excludedVehicles.length ? excludedVehicles : undefined
  }

  _getExcludedAdIds = () => {
    if (this._excludedAdIds && this._excludedAdIds.length > 0) {
      return this._excludedAdIds.map(id => parseInt(id, 10)).filter(id => Boolean(id))
    }
  }

  cleanUndefinedKeys = object => JSON.parse(JSON.stringify(object))

  map = () => {
    const filters = {
      ...this.getColorIds(),
      ...this.getCubicCapacity(),
      ...this.getPrices(this._hasInstalment),
      ...this.getFee(),
      ...this.getCommitmentMonths(),
      ...this.getPriceRank(),
      batteryCapacity: this._batteryCapacity,
      bodyTypeIds: this._bodyTypeIds,
      categories: this.getCategories(),
      chargingTimeFastMode: this._chargingTimeFastMode,
      chargingTimeStandardMode: this._chargingTimeStandardMode,
      contractId: this._contractId,
      doors: this._getDoors(),
      drivenWheelsIds: this._drivenWheelsIds,
      electricAutonomy: this._electricAutonomy,
      entry: this._entry,
      environmentalLabels: this._environmentalLabels,
      equipments: this._equipments,
      excludedAdIds: this._getExcludedAdIds(),
      excludedVehicles: this._getExcludedVehicles(),
      fuelTypeIds: this._fuelTypeIds,
      hasPriceDrop: this._hasPriceDrop,
      hasPhoto: this._hasPhoto,
      hasOnlineFinancing: this._hasOnlineFinancing,
      hasReservation: this._hasReservation,
      hasStock: this._hasStock,
      hasWarranty: this._hasWarranty,
      hp: this._hp,
      isCertified: this._isCertified,
      km: this._kms,
      location: this._getLocation(),
      luggageCapacity: this._luggageCapacity,
      maxTerms: this._maxTerms,
      monthlySubscriptionFee: this._monthlySubscriptionFee,
      onlyPeninsula: this._onlyPeninsula,
      offerTypeIds: this.getOfferTypeIds(),
      priceDrop: this._priceDrop,
      provinceIds: this._provinceIds,
      rating: this._rating,
      searchText: this._searchText,
      seats: this._getSeats(),
      sellerTypeId: this._sellerTypeId,
      subscriptionVehicleState: this._subscriptionVehicleState,
      targetBuyer: this._targetBuyer,
      transmissionTypeId: this._transmissionTypeId,
      vehicleLength: this._vehicleLength,
      vehicles: this.getVehicles(),
      year: this._year
    }

    return this.cleanUndefinedKeys({
      pagination: {page: this._page, size: this._size || this._adsListSize},
      sort: {
        order: ORDER[this._sortOrder].toLowerCase(),
        term: this._getSortBy({sortBy: this._sortBy})
      },
      filters: this.cleanUndefinedProperties(filters)
    })
  }
}
